module.exports = __webpack_public_path__ + "img/rubico_black.369ffcee.png";